module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/ryokan_worker_female-8ee5882bf1ffb50bd73b0ba1094c8abe.webp";